import React from "react";
import HeaderNav from "../../header/header";
import {
    Button,
    Checkbox,
    Col,
    DatePicker,
    Form,
    Input,
    Layout,
    message,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Table
} from "antd";
import moment from 'moment';
import "../css/SingleCreateFinancialClaim.css"
import {Option} from "antd/es/mentions";
import {basic_info, financial_claim_query, financial_claim_approval, financial_claim_detail} from "../../../requist";

const { Content } = Layout;

class CBSOClaimApproval extends React.Component{
        formRef = React.createRef();
        constructor(props) {
            super(props);
            this.state={
                selectedRowKeys:[],
                isModalVisible:false,
                basic_info:'',
                data:[],
                selectedRows:[],
                detailData:null,
                loading:false,
                approvaling: false,
                rejecting: false
            }
            this.columns = [
                {
                    title: 'Dispute Number',
                    dataIndex: 'billingInstruction',
                    width: 250,
                },
                {
                    title: 'Claim Request No',
                    dataIndex: 'claimReqNo',
                    width: 250,
                },
                {
                    title: 'Claim ID',
                    dataIndex: 'claimId',
                    width: 250,
                    render:((text,record)=>{
                        return <a onClick={()=>{
                            this.setState({isModalVisible:true})
                            let params={
                                claimId:text,
                                claimReqNo:record.claimReqNo
                            }
                            financial_claim_detail(params).then(res=>{
                                const {retCode,retMsg,data} = res;
                                if(retCode==='200'){
                                    this.setState({detailData:data})
                                }else{
                                    message.error(`${retMsg}`)
                                }
                            })
                        }
                        }>{text}</a>
                    })
                },
                {
                    title: 'Dispute Number',
                    dataIndex: 'disputeNumber',
                    width: 250,
                },
                {
                    title: 'Sold To Party',
                    dataIndex: 'soldTo',
                    width: 250,
                },
                // {
                //     title: 'Customer Name',
                //     dataIndex: 'customerName',
                // },
                {
                    title: 'Invoice No',
                    dataIndex: 'invoiceNo',
                    width: 250,
                },
                {
                    title: 'Claim Value',
                    dataIndex: 'claimValue',
                    width: 250,
                },
                {
                    title: 'Currency',
                    dataIndex: 'currency',
                    width: 250,
                },
                {
                    title: 'Claim Type',
                    dataIndex: 'claimType',
                    width: 250,
                },
                {
                    title: 'Order Reason Description',
                    dataIndex: 'OrderReasonDescription',
                    width: 250,
                },
                {
                    title: 'claim Category',
                    dataIndex: 'claimCategory',
                    width: 250,
                },
                {
                    title: 'Sales Org',
                    dataIndex: 'salesOrg',
                    width: 250,
                },
                {
                    title: 'Sales Office',
                    dataIndex: 'salesOffice',
                    width: 250,
                },
                {
                    title: 'BP-Reference',
                    dataIndex: 'bpRef',
                    width: 250,
                },
                {
                    title: 'Customer PO No.',
                    dataIndex: 'poNumber',
                    width: 250,
                },
                {
                    title: 'Created On',
                    dataIndex: 'createdOn',
                    width: 250,
                },
                {
                    title: 'Created By',
                    dataIndex: 'createdBy',
                    width: 250,
                },
                {
                    title: 'Changed On',
                    dataIndex: 'eccCreatedOn',
                    width: 250,
                },
                {
                    title: 'Changed By',
                    dataIndex: 'changedBy',
                    width: 250,
                },
                {
                    title: 'Status',
                    dataIndex: 'statusText',
                    width: 250,
                },
            ];
            this.columnsItem=[
                {
                    title: 'Claim Item No',
                    dataIndex: 'claimReqItem',
                    width: 250,
                },
                {
                    title: 'Material',
                    dataIndex: 'partNumber',
                    width: 250,
                },
                {
                    title: 'Message',
                    dataIndex: 'message',
                    width: 250,
                },
                {
                    title: 'Quantity',
                    dataIndex: 'quantity',
                    width: 250,
                },
                {
                    title: 'End User Name',
                    dataIndex: 'endUserName',
                    width: 250,
                },
                {
                    title: 'Unit Claim Value',
                    dataIndex: 'unitClaimValue',
                    width: 250,
                },
                {
                    title: 'Claim Value',
                    dataIndex: 'claimValue',
                    width: 250,
                },
                {
                    title: 'Serial Number',
                    dataIndex: 'serialNumbers',
                    width: 250,
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    width: 250,
                },
                {
                    title: 'SO Number',
                    dataIndex: 'soNumber',
                    width: 250,
                },
                {
                    title: 'Delivery Number',
                    dataIndex: 'deliveryNumber',
                    width: 250,
                },
                {
                    title: 'Billing Number',
                    dataIndex: 'billingNo',
                    width: 250,
                },
                {
                    title: 'Processing Log',
                    dataIndex: 'processingLog',
                    width: 250,
                },
                {
                    title: 'Deletion Indicator',
                    dataIndex: 'deletionIndicator',
                    width: 250,
                },
            ]
        }
        componentWillMount(){
            let uesrId = window.localStorage.getItem('userId')
            if(!uesrId){
                message.warn('Please log in first!')
                this.props.history.push({
                    pathname: '/disputeHome'
                })
            }else{
                basic_info().then((res)=>{
                    let {data,retCode,retMsg} = res;
                    if(retCode==="200"){
                        this.setState({basic_info:data})
                    }else{
                        message.warn(`${retMsg}`)
                    }
                })
            }
        }
        onSelectChange = (selectedRowKeys,selectedRows) => {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.setState({ selectedRowKeys,selectedRows });
        };
    onFinish=(values)=>{
        this.setState({loading:true})
        values.claimReqNo = values.claimReqNo?values.claimReqNo:undefined
        values.bpReference = values.bpReference?values.bpReference:undefined
        values.claimId = values.claimId?values.claimId:undefined
        values.soldTo = values.soldTo?values.soldTo:undefined
        values.createdBy = values.createdBy?values.createdBy:undefined
        values = {
            ...values,
            eccCreatedOnFrom: values.eccCreatedOnFrom ? moment(values.eccCreatedOnFrom).format('YYYY-MM-DD') + ' 00:00:00' : undefined,
            eccCreatedOnTo: values.eccCreatedOnTo ? moment(values.eccCreatedOnTo).format('YYYY-MM-DD') + ' 00:00:00' : undefined,
            status:values.errorOrder?['FERRO']:values.status?values.status:['FCRAT','FCHAN','FAPPF'],
            cbso:true
        }
        financial_claim_query(values).then(res=>{
            const {retCode,data} = res;
            if(retCode==="200"){
                this.setState({data:data})
                this.setState({loading:false})
            }else{
                this.setState({loading:false})
                message.warn(`${res.retMsg}`)
            }
        })
    }
    onApproval=()=>{
        const {selectedRows,dataSource} = this.state;
        let userId = window.localStorage.getItem('userId')
        let values={
            action:1,
            claims:selectedRows,
            userId:userId
        }
        this.setState({
            approvaling: true
        })
        financial_claim_approval(values).then(res=>{
            const {retCode,retMsg,data} = res
            if(retCode==="200"){
                let newData
                data.forEach((item)=>{
                    dataSource.forEach((item_d,i)=>{
                        if(item.id==item_d.id){
                            dataSource.splice(i,1)
                        }
                    })
                })
                newData = data.concat(dataSource)
                this.setState({
                    selectedRowKeys:[],
                    loading:false,
                    dataSource:newData.sort((a, b) => {
                        return b.value - a.value
                    }),
                    approvaling: false
                })
                message.success(`${retMsg}`)
            }else{
                this.setState({
                    approvaling: false
                })
                message.error(`${retMsg}`)
            }
        })
    }
    onRejection=()=>{
        const {selectedRows,dataSource} = this.state;
        let userId = window.localStorage.getItem('userId')
        let values={
            action:2,
            claims:selectedRows,
            userId:userId
        }
        this.setState({
            rejecting: true
        })
        financial_claim_approval(values).then(res=>{
            const {retCode,retMsg,data} = res
            if(retCode==="200"){
                let newData;
                data.forEach((item)=>{
                    dataSource.forEach((item_d,i)=>{
                        if(item.id==item_d.id){
                            dataSource.splice(i,1)
                        }
                    })
                })
                newData = data.concat(dataSource)
                this.setState({
                    selectedRowKeys:[],
                    loading:false,
                    dataSource:newData.sort((a, b) => {
                        return b.value - a.value
                    }),
                    rejecting: false
                })
                message.success(`${retMsg}`)
            }else{
                this.setState({
                    rejecting: false
                })
                message.error(`${retMsg}`)
            }
        })
    }
    handleOk=()=>{
        this.setState({isModalVisible:false})
    }
    handleCancel=()=>{
        this.setState({isModalVisible:false})
    }
    dpSplit=(e)=>{
        let value = e.target.value
        if (value.indexOf(" ") == -1) {

        } else {
            if(value){
                this.formRef.current.setFieldsValue({disputeNo:value.trim().split(/\s+/)})
            }
        }
    }
    render() {
        const { selectedRowKeys,data,basic_info,isModalVisible,detailData,loading } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return <div>
            <HeaderNav parmas={'/CBSOClaimApproval'}/>
            <Layout className="site-layout-background singleFinancialClaimEdit" style={{ padding: '24px 0',margin: '0 auto'  }}>
                { detailData &&  <Modal title="Financial Claim Detail"
                                        width={1200}
                                        visible={isModalVisible}
                                        onOk={this.handleOk}
                                        onCancel={this.handleCancel}
                                        destroyOnClose={true}
                >
                    <Form
                        name="CBSOClaimDetail"
                        labelCol={{span: 12}}
                        wrapperCol={{span: 10}}
                        preserve={false}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Number"
                                    name="billingInstruction"
                                >
                                    <span>{`${detailData[0].billingInstruction}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Request No"
                                    name="claimReqNo"
                                >
                                    <span>{`${detailData[0].claimReqNo}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim ID"
                                    name="claimId"
                                >
                                    <span>{`${detailData[0].claimId}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Invoice No"
                                    name="invoiceNo"
                                >
                                    <span>{`${detailData[0].invoiceNo}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Party"
                                    name="soldTo"
                                >
                                    <span>{`${detailData[0].soldTo}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Bill to Party"
                                    name="billTo"
                                >
                                    <span>{`${detailData[0].billTo}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Category"
                                    name="claimCategory"
                                >
                                    <span>{`${detailData[0].claimCategory}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Pricing Date"
                                    name="pricingDate"
                                >
                                    <span>{`${detailData[0].pricingDate}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Requested Delivery Date"
                                    name="reqDeliveryDate"
                                >
                                    <span>{`${detailData[0].reqDeliveryDate}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Org"
                                    name="salesOrg"
                                >
                                    <span>{`${detailData[0].salesOrg}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Currency"
                                    name="currency"
                                >
                                    <span>{`${detailData[0].currency}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Purchase Order Number"
                                    name="poNumber"
                                >
                                    <span>{`${detailData[0].poNumber}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Office"
                                    name="salesOffice"
                                >
                                    <span>{`${detailData[0].salesOffice}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="SBO-No/ SOP Ref. /Lenovo Ref"
                                    name="lenovoRef"
                                >
                                    <span>{`${detailData[0].lenovoRef}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Channel"
                                    name="channel"
                                >
                                    <span>{`${detailData[0].channel}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="BP-Reference"
                                    name="bpRef"
                                >
                                    <span>{`${detailData[0].bpRef}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Country"
                                    name="country"
                                >
                                    <span>{`${detailData[0].country}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Type"
                                    name="claimType"
                                >
                                    <span>{`${detailData[0].claimType}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Street/ House No"
                                    name="street"
                                >
                                    <span>{`${detailData[0].street}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Street 2"
                                    name="street2"
                                >
                                    <span>{`${detailData[0].street2}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Ship to Party"
                                    name="shipTo"
                                >
                                    <span>{`${detailData[0].shipTo}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Postal Code"
                                    name="postalCode"
                                >
                                    <span>{`${detailData[0].postalCode}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="City"
                                    name="city"
                                >
                                    <span>{`${detailData[0].city}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Contact Person"
                                    name="contactPerson"
                                >
                                    <span>{`${detailData[0].contactPerson}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                >
                                    <span>{`${detailData[0].email}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Phone number"
                                    name="phoneNumber"
                                >
                                    <span>{`${detailData[0].phoneNumber}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Comment"
                                    name="comment"
                                >
                                    <span>{`${detailData[0].comment}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Billing Instruction"
                                    name="billingInstruction"
                                >
                                    <span>{`${detailData[0].billingInstruction}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Created Date"
                                    name="createdOn"
                                >
                                    <span>{`${detailData[0].createdOn}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Created Time"
                                    name="createdTime"
                                >
                                    <span>{`${detailData[0].createdTime}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Created By"
                                    name="createdBy"
                                >
                                    <span>{`${detailData[0].createdBy}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Approved Date"
                                    name="approvedAt"
                                >
                                    <span>{`${detailData[0].approvedAt}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Approved Time"
                                    name="approveTime"
                                >
                                    <span>{`${detailData[0].approveTime}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Approved By"
                                    name="approvedBy"
                                >
                                    <span>{`${detailData[0].approvedBy}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Changed Date"
                                    name="changeDate"
                                >
                                    <span>{`${detailData[0].changeDate}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Changed Time"
                                    name="changedTime"
                                >
                                    <span>{`${detailData[0].changedTime}`}</span>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Changed By"
                                    name="changedBy"
                                >
                                    <span>{`${detailData[0].changedBy}`}</span>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item style={{textAlign: 'right'}}>
                        </Form.Item>
                        <div style={{margin: '0 auto'}}>
                            <h1>Claim Item</h1>
                            <Table
                                scroll={{x: 1700,y: 500}}
                                columns={this.columnsItem}
                                rowKey={'claimId'}
                                dataSource={detailData}
                                bordered
                            />
                        </div>
                    </Form>
                </Modal>}
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>Approve CBSO Financial Claim</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:12 }}
                        wrapperCol={{ span: 12}}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Number"
                                    name="disputeNo"
                                    rules={[{ required: false }]}
                                    tooltip={'Dispute No can input multi-value and it should be separated by comma'}
                                >
                                    <Input onChange={this.dpSplit} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Request No"
                                    name="claimReqNo"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim ID"
                                    name="claimId"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="BP-Reference"
                                    name="bpReference"
                                    rules={[{ required: false }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Type"
                                    name="claimType"
                                    rules={[{ required: false }]}
                                >
                                    <Select placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.claimTypeList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Invoice No"
                                    name="invoiceNo"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Category"
                                    name="claimCategory"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.claimCategoryList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Party"
                                    name="soldTo"
                                    rules={[{ required: false}]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Org"
                                    name="salesOrg"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.salesOrgList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create From"
                                    name="eccCreatedOnFrom"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create To"
                                    name="eccCreatedOnTo"
                                    rules={[{ required: true }]}
                                    initialValue={moment(new Date())}
                                >
                                    <DatePicker />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Office"
                                    name="salesOffice"
                                    rules={[{ required: false }]}
                                >
                                    <Select dropdownMatchSelectWidth={240} placeholder={'Please select'}>
                                        {
                                            basic_info?basic_info.salesOfficeList.map(item=>{
                                                return <Option value={item.TGT01} >{item.TGT01} | {item.TGT02}</Option>
                                            }):''
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Created By"
                                    name="createdBy"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Status"
                                    name="status"
                                    rules={[{ required: false }]}
                                >
                                    <Select mode="tags" placeholder={'Please select'}>
                                        <Option value={'FCRAT'}>Financial claim created</Option>
                                        <Option value={'FCHAN'}>Financial claim changed</Option>
                                        <Option value={'FAPPF'}>Financial claim approve failed</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Error Order"
                                    name="errorOrder"
                                    valuePropName={'checked'}
                                >
                                    <Checkbox />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Contract Number"
                                    name="contractNumber"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Asset Location"
                                    name="assetLocation"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24} style={{marginBottom:20,textAlign:'right'}}>
                                <Space>
                                    <Button type="primary" disabled={this.state.approvaling} onClick={this.onApproval}>
                                        Approval
                                    </Button>
                                    <Button type="primary" disabled={this.state.rejecting} onClick={this.onRejection}>
                                        Rejection
                                    </Button>
                                    <Button type="primary" htmlType="submit">
                                        Search
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                    <Table
                        scroll={{y: 500}}
                        rowSelection={rowSelection}
                        columns={this.columns}
                        rowKey={'claimId'}
                        dataSource={data}
                        bordered
                    />

                </Content>
            </Layout>
        </div>
    }
}

export default CBSOClaimApproval;